const DisabledReducer = (state, action) => ({
  map: () => DisabledReducer(state, action),
  fold: () => [true, state],
  foldState: () => state
})

export const Reducer = (state, action) => ({
  map: f => {
    const [changed, newState] = f(state, action)
    // If action is false, disable the chain
    if (!!changed) {
      return DisabledReducer(newState, action)
    }
    return Reducer(newState, action)
  },
  fold: () => [false, state],
  foldState: () => state
})
